<storever-loading-data *ngIf="isLoading else dataForm"></storever-loading-data>
<ng-template #dataForm>
  <form [formGroup]="form" class="formHeight">
    <ul class="list-group">
      <div class="width-25">
        <storever-element-group
          [icon]="'fal fa-exclamation'"
          [title]="'SHIPPINGS_EDIT_TITLE_MAIN'"
          [config]="getConfigGeneral.config"
          [form]="form.get(['general'])"
          [isAdd]="isAdd"
          [isEdit]="isEdit && (isInRole$('BO_SHIPPING_EDIT') | async)"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'order', case: 'general'}"
          (save)="save('general')"
          (undo)="undo(['general'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
      <div class="width-25 datePickerInput">
        <storever-element-group
          [icon]="'fad fa-paper-plane'"
          [title]="'SHIPPINGS_EDIT_TITLE_SENDING_TYPE'"
          [config]="getConfigSendingType.config"
          [form]="form.get('sendingType')"
          [isAdd]="isAdd"
          [isEdit]="isEdit && (isInRole$('BO_SHIPPING_EDIT') | async)"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'order', case: 'sendingType'}"
          (save)="save('sendingType')"
          (undo)="undo(['sendingType'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
      <div class="width-25">
        <storever-element-group
          [icon]="'fad fa-money-check-edit'"
          [title]="'SHIPPINGS_EDIT_TITLE_BILLING'"
          [config]="getConfigBilling.config"
          [form]="form.get('billing')"
          [isAdd]="isAdd"
          [isEdit]="isEdit && (isInRole$('BO_SHIPPING_EDIT') | async)"
          [paramEdit]="{ text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'order', case: 'billing'}"
          (save)="save('billing')"
          (undo)="undo(['billing'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
      <div class="width-25">
        <storever-element-group
          [icon]="'fa-comment-alt-lines'"
          [title]="'GENERIC_COMMENT'"
          [config]="getConfigShippingMisc.config"
          [form]="form.get(['misc', 'commentsForm'])"
          [isAdd]="isAdd"
          [isEdit]="isEdit && (isInRole$('BO_SHIPPING_EDIT') | async)"
          [status]="0"
          [paramEdit]="{text: 'GENERIC_ADD', icon: 'fal fa-comment-plus', type: 'order', case: 'comments'}"
          (save)="save('comments')"
          (undo)="undo(['misc', 'commentsForm'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
      <div class="width-25">
        <storever-element-group class="checkbox"
          [icon]="'fa-address-book'"
          [title]="'ORDER_FORM_TITLE_ADDRESS'"
          [config]="formConfigAddress.config"
          [selectOption]="selectOption"
          [form]="form.get('address')"
          [selectOptionDefault]="form.get(['address' ,'addressType']).value ? form.get(['address' ,'addressType']).value : null"
          [listSelectOption]="addressSummaries"
          [isAdd]="isAdd"
          [isEdit]="isEdit && (isInRole$('BO_SHIPPING_EDIT') | async)"
          [paramEdit]="!form.get(['general', 'siteName']).value ? { text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'order', case: 'billing'} : {text: 'none', icon: 'fal fa-edit', type: 'order', case: 'address'}"
          (selectOptionUpdate)="updateAddressAndContact($event)"
          (save)="save('addressSite')"
          (undo)="undo(['address'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
      <div class="width-25">
        <storever-element-group
          [icon]="'fa-id-card'"
          [title]="'ORDER_FORM_TITLE_CONTACT'"
          [config]="formConfigContact.config"
          [form]="form.get('contact')"
          [isAdd]="isAdd"
          [isEdit]="isEdit && (isInRole$('BO_SHIPPING_EDIT') | async)"
          [paramEdit]="!form.get(['general', 'siteName']).value ? { text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'order', case: 'billing'} : {text: 'none', icon: 'none', type: 'order', case: 'none'}"
          (save)="save('contact')"
          (undo)="undo(['contact'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
      <div class="width-25" style="text-align: center;" *ngIf="showWaybill">
        <storever-element-group
        #elementGroup
        [icon]="'fa fa-barcode'"
        [title]="'Waybill'"
        [config]="getConfigWaybill.config"
        [form]="form">
      </storever-element-group>
        <button type="button" class="btn btn-primary" (click)="openwindow()"> {{'Get waybill'}} </button>
      </div>
      <div class="width-25">
        <storever-element-group
        *ngIf="isEdit"
        [icon]="'fa-info-circle'"
        [title]="'ORDER_FORM_TITLE_OTHERS'"
        [config]="getConfigMiscCreated.config"
        [form]="form.get(['misc', 'byForm'])"
        [isAdd]="isAdd"
        [isEdit]="isEdit && (isInRole$('BO_SHIPPING_EDIT') | async)"
        [paramEdit]="{text: 'none', icon: 'none', type: 'order', case: 'none'}"
        [stylingClass]="'dynamic-form'" >
      </storever-element-group></div>
    </ul>
  </form>
</ng-template>

<div *ngIf="false" style="display:flex;">
  <!--  <pre style="flex: 1 1 0px">dataConfig: {{dataConfig|json}}</pre>-->
  <pre style="flex: 1 1 0px">dataConfig form: {{getInvalidControls(form)}}</pre>
</div>
